import { useMemo } from 'react';
import { collectorsPageRoute } from 'modules/Collectors/collectorsRoute';
import { TIRouteProps } from 'modules/common';
import { notesPageRoute } from 'modules/notes';
import { smartDiaryPageRoute } from 'modules/smartDiary';
import { useMeContext } from 'modules/me';
import { InsightsPageRoute } from 'modules/Insights/InsightsPageRoute';
import { useFeatureFlag } from 'modules/common/hooks';
import { getParsedJwt, getTokens } from 'modules/oauth/tokenStore';

export const useDefaultRoutes = (): TIRouteProps[] => {
  const me = useMeContext();
  const isTiWebNotesInsightsPageEnabled = useFeatureFlag(
    'isTiWebNotesInsightsPageEnabled'
  );

  const hasViewCollectorsAccess = useMemo(() => {
    const token = getTokens();
    const value = getParsedJwt(token?.accessToken);
    const tokenPermission = value?.scope?.includes('collectors:settings');
    return tokenPermission && me?.permissions?.hasViewCollectorsAccess;
  }, [me?.permissions?.hasViewCollectorsAccess]);

  return useMemo(() => {
    const defaultRoutes = [notesPageRoute, smartDiaryPageRoute];
    if (hasViewCollectorsAccess) {
      defaultRoutes.push(collectorsPageRoute);
    }
    if (isTiWebNotesInsightsPageEnabled) {
      defaultRoutes.push(InsightsPageRoute);
    }
    return defaultRoutes;
  }, [hasViewCollectorsAccess, isTiWebNotesInsightsPageEnabled]);
};
